import { useState, useEffect } from 'react';
import { Checkbox, Button, Space, Typography, Spin, message } from 'antd';
import { api } from '../api';

const { Text } = Typography;

export default function DelivererStoresForm({ deliverer, onSaved }) {
  const [stores, setStores]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    api.stores.list()
      .then(list => {
        setStores(list);
        setSelected(list.filter(s => s.deliverer_id === deliverer.id).map(s => s.id));
      })
      .catch(err => message.error(err.message))
      .finally(() => setLoading(false));
  }, [deliverer.id]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const selectedSet = new Set(selected);
      await Promise.all(stores.map(store => {
        const currentlyAssigned = store.deliverer_id === deliverer.id;
        const shouldBeAssigned  = selectedSet.has(store.id);
        if (currentlyAssigned === shouldBeAssigned) return null;
        return api.stores.setDeliverer(store.id, shouldBeAssigned ? deliverer.id : null);
      }).filter(Boolean));
      message.success('Zuordnung gespeichert');
      onSaved?.();
    } catch (err) {
      message.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spin style={{ display: 'block', marginTop: 32 }} />;

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={16}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Stores, für die <strong>{deliverer.name}</strong> liefert:
      </Text>
      <Checkbox.Group
        value={selected}
        onChange={setSelected}
        style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
      >
        {stores.map(store => (
          <Checkbox key={store.id} value={store.id}>
            {store.name}
            {store.deliverer_id && store.deliverer_id !== deliverer.id && (
              <Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>
                (aktuell: anderer Lieferant)
              </Text>
            )}
          </Checkbox>
        ))}
      </Checkbox.Group>
      <Button type="primary" loading={saving} onClick={handleSave} style={{ marginTop: 8 }}>
        Speichern
      </Button>
    </Space>
  );
}
